import Item from "./Item";

export default class CreatePayment {
	items: Array<Item>;

	constructor() {
		this.items = new Array<Item>();
	}
}
